import { gql } from "apollo-boost";
//QUERY
export const CONSULTORY_PARAMETERS_AND_ORDER = gql`
  query consultoryParametersAndOrder($where: ConsultoryParametersInput) {
    consultoryParametersAndOrder(where: $where) {
      medicalParameterGroupId
      nameParameterGroup
      order
    } 
  }
`;

export const GET_APPOINTMENT_DATA = gql`
  query getAppointment($where: AppointmentWhereInput, $relations: [String]) {
    getAppointment(where: $where, relations: $relations) {
      id
      createUser
      date
      appointmentDate
      appointmentHour
      appointmentStart
      appointmentEnd
      appointmentType
      isSaveAppointment
      arsId
      pharmacyProviderId
      patientId
      specialityId
      medicalStaffId
      statusId
      servicesId
      enabled
      weekDayId
      ars {
        name
      }
      services {
        id
        name
        requiresResult
      }
      status {
        id
        name
      }
      patient {
        id
        fullname
        firstName
        lastName
        identificationCard
        noAffiliate
        arsId
        dateOfBirth
        deniesHistory
        gender {
          id
          name
        }
        ars {
          name
        }
      }
    }
  }
`;

export const GET_LAST_APPO_HISTO = gql`
  query getLastAppoHisto(
    $where: AppointmentHistoriesByIdWhereInput
    $relations: [String]
  ) {
    getLastAppoHisto(where: $where, relations: $relations) {
      id
      date
      reason
      diseaseHistory
      appointmentId
      patientId
      physicalExamId
      medicalStaffId
      createAt
      imc
      appointmentHistoryMedicalParameter {
        id
        appointmentId
        patientId
        medicalParameterTypeId
        medicalParameterValue
        medicalParameterGroupId
        observation
        medicalParameterId
        appointmentHistoryId
        medicalParameters {
          id
          name
          fillInAppointment
          min
          max
          minAge
          maxAge
          value
          unitOfMeasurement
          genderId
          typeId
          frequencyId
          enabled
        }
      }
      appointmentHistoryServices {
        id
        appointmentId
        quantity
        result
        insuredCoverage
        consultoryDifferent
        patientId
        isQuantization
        consultoryFee
        insuredContrated
        insuredCopay
        quotationId
        services {
          id
          name
          requiresResult
        }
      }
      appointmentHistoryMedicalPrecription {
        id
        branchOfficeId
        pharmacyProviderId
        patientId
        arsId
        doctorId
        recipeType {
          id
          name
        }
        precriptionDetails {
          id
          quantity
          frecuency
          frecuencyDaysHours
          duration
          durationDaysWeeksMonths
          totalDosis
          doctorNote
          medicine {
            id
            name
          }
        }
      }
      appointmentHistoryLaboratory {
        id
        appointmentId
        patientId
        laboratoryExamId
        resultDate
        examLabel
        createAt
        laboratoryExam {
          id
          name
          productType {
            prescriptionSeparate
          }
        }
        files {
          id
          fileKey
          originalName
          mimetype
          sizeBytes
          path
        }
      }
      appointmentHistoryImages {
        id
        appointmentId
        patientId
        imageExamId
        resultDate
        examLabel
        createAt
        imageExam {
          id
          name
          productType {
            prescriptionSeparate
          }
        }
        files {
          id
          fileKey
          originalName
          mimetype
          sizeBytes
          bucket
          path
        }
      }
      appointmentHistoryLicenses {
        id
        days
        description
        appointmentId
        code
        date
        patientId
        licensesTypes {
          id
          name
          description
          maxDays
        }
      }
      appointmentHistoryReferral {
        id
        patientId
        observation
        medicalName
        createAt
        speciality {
          id
          name
        }
      }
      appointmentHistoryDiagnoses {
        id
        order
        diagnoses {
          id
          code
          description
        }
      }
      quotations {
        id
        quotationsDetails {
          id
          quantity
          insuredContrated
          insuredCoverage
          insuredCopay
          consultoryFee
          consultoryDifferent
          product {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_DATA_HISTORY_REPORT = gql`
  query getDataHistoryReport($where: AppointmentHistoriesByIdWhereInput) {
    getDataHistoryReport(where: $where) {
      id
      medicalStaff {
        id
        name
        firstName
        middleName
        lastName
        lastName2
        username
        phone
        phone2
        cellphone
        email
        exequatur
        identificationCard
        genderId
        specialitiesByMedical {
          speciality {
            id
            name
          }
        }
      }
      patient {
        id
        firstName
        middleName
        lastName
        lastName2
        dateOfBirth
        gender {
          id
          name
        }
        identificationCard
        email
        numChildren
        address
        phone
        arsId
        noAffiliate
        noContract
        socialSecurityNumber
        isDependent
        identificationCardHolder
        nameHolder
        enabled
      }
      appointmentHistoryMedicalPrecription {
        id
        date
        expiryDate
        prescriptionNumber
        branchOffice {
          id
          name
          contact
          email
          phone
          enabled
          pharmacyProviderId
          address
        }
        pharmacyProvider {
          id
          name
          email
        }
        arsEntity {
          id
          name
        }
        recipeType {
          id
          name
        }
        precriptionDetails {
          id
          quantity
          frecuency
          frecuencyDaysHours
          duration
          durationDaysWeeksMonths
          totalDosis
          doctorNote
          medicine {
            id
            name
          }
        }
      }
      appointmentHistoryLaboratory {
        id
        appointmentId
        patientId
        laboratoryExamId
        resultDate
        examLabel
        code
        createAt
        laboratoryExam {
          id
          name
          productType {
            prescriptionSeparate
          }
        }
        files {
          id
          fileKey
          originalName
          mimetype
          sizeBytes
          path
        }
      }
      appointmentHistoryImages {
        id
        appointmentId
        imageExamId
        resultDate
        examLabel
        code
        createAt
        imageExam {
          id
          name
          patientId
          productType {
            prescriptionSeparate
          }
        }
        files {
          id
          fileKey
          originalName
          mimetype
          sizeBytes
          bucket
          path
        }
      }
      appointmentHistoryLicenses {
        id
        days
        description
        appointmentId
        code
        date
        patientId
        licensesTypes {
          id
          name
          description
          maxDays
        }
      }
      appointmentHistoryReferral {
        id
        patientId
        observation
        medicalName
        code
        createAt
        speciality {
          id
          name
        }
      }
      quotations {
        id
        code
        date
        totalConsultoryDifferent
        totalConsultoryFee
        totalInsuredCopay
        totalInsuredContrated
        totalConsultoryCoverage
        expirationDate
        quotationsDetails {
          id
          quantity
          insuredContrated
          insuredCoverage
          insuredCopay
          consultoryFee
          consultoryDifferent
          differencePlusQuantity
          product {
            id
            name
          }
        }
      }
    }
  }
`;

export const CONSULTORY_PARAMETERS = gql`
  query consultoryParameters(
    $where: ConsultoryParametersInput
    $relations: [String]
  ) {
    consultoryParameters(where: $where, relations: $relations) {
      medicalParameterGroupId
      consultoryParametersDetail {
        id
        enabled
        required
        frequencyId
        medicalParameters {
          id
          name
          fillInAppointment
          min
          max
          minAge
          maxAge
          value
          unitOfMeasurement
          genderId
          typeId
          frequencyId
          enabled
        }
      }
    }
  }
`;

export const GET_CONSULTORY_SERVICES = gql`
  query consultoryServices(
    $where: ConsultoryServicesInput
    $relations: [String]
  ) {
    consultoryServices(where: $where, relations: $relations) {
      id
      product {
        id
        name
        requiresResult
        isAppointment
      }
      consultoryServicesDetail {
        id
        insuredContrated
        insuredCoverage
        insuredCopay
        consultoryFee
        consultoryDifferent
        enabled
        ars {
          id
          name
        }
      }
    }
  }
`;

// export const GET_MEDICINE = gql`
//   query getMedicine2($where: MedicineWhereInput) {
//     items: getMedicine2(where: $where) {
//       # id
//       # Product_id
//       Product_Name
//       Molecule
//       # Line_ID
//       Line_Description
//       Price
//       plan
//       # Supplemental_plan
//       product_detail
//       CodigoPDSS
//       medicineId
//       Product_id: rdfCode
//     }
//   }
// `;

export const GET_MEDICINE = gql`
  query getMedicineByTherapeutic($where: therapeuticWhereInput) {
    items: getMedicineByTherapeutic(where: $where) {
      # id
      # Product_id
      Product_Name
      # Line_ID
      Line_Description
      Price
      isDetailing
      NoDetallable
      product_detail
      # CodigoPDSS
      medicineId
      Product_id: rdfCode
    }
  }
`;

export const GET_RECIPE_TYPE = gql`
  query recipeTypes {
    recipeTypes {
      id
      name
      enabled
      isPyp
    }
  }
`;

export const GET_PRODUCT = gql`
  query products($where: ProductWhereInput, $relations: [String]) {
    products(where: $where, relations: $relations) {
      id
      name
      productType {
        id
        name
        prescriptionSeparate
      }
    }
  }
`;

export const GET_LICENSES_TYPES = gql`
  query licensesTypes($where: LicensesWhereInput) {
    licensesTypes(where: $where) {
      id
      name
      description
      maxDays
      enabled
    }
  }
`;

export const GET_SPECIALITIES = gql`
  query specialities($where: SpecialityWhereInput) {
    specialities(where: $where) {
      id
      name
    }
  }
`;

export const GET_MEDICAL_STAFFS = gql`
  query getRdfMedicalStaffs($where: RdfMedicalStaffWhereInput) {
    getRdfMedicalStaffs(where: $where) {
      id
      fullname
    }
  }
`;

export const GET_DIAGNOSES = gql`
  query diagnoses($where: DiagnosesI) {
    diagnoses(where: $where) {
      id
      code
      description
      enabled
    }
  }
`;

//MUTATION
export const CREATE_APPOINTMENT_HISTORY = gql`
  mutation createAppointmetHistory($data: createAppointmentHistoryInput) {
    createAppointmetHistory(data: $data) {
      id
      medicalStaff {
        id
        name
        firstName
        middleName
        lastName
        lastName2
        username
        phone
        email
        exequatur
        identificationCard
        genderId
        specialitiesByMedical {
          speciality {
            id
            name
          }
        }
      }
      patient {
        id
        firstName
        middleName
        lastName
        lastName2
        dateOfBirth
        gender {
          id
          name
        }
        identificationCard
        email
        numChildren
        address
        phone
        arsId
        noAffiliate
        noContract
        socialSecurityNumber
        isDependent
        identificationCardHolder
        nameHolder
        enabled
      }
      appointmentHistoryMedicalPrecription {
        id
        date
        expiryDate
        prescriptionNumber
        branchOffice {
          id
          name
          contact
          email
          phone
          enabled
          pharmacyProviderId
          address
        }
        pharmacyProvider {
          id
          name
          email
        }
        arsEntity {
          id
          name
        }
        recipeType {
          id
          name
        }
        precriptionDetails {
          id
          quantity
          frecuency
          frecuencyDaysHours
          duration
          durationDaysWeeksMonths
          totalDosis
          doctorNote
          medicine {
            id
            name
          }
        }
      }
      appointmentHistoryLaboratory {
        id
        appointmentId
        patientId
        laboratoryExamId
        resultDate
        examLabel
        laboratoryExam {
          id
          name
          productType {
            prescriptionSeparate
          }
        }
        files {
          id
          fileKey
          originalName
          mimetype
          sizeBytes
          path
        }
      }
      appointmentHistoryImages {
        id
        appointmentId
        imageExamId
        resultDate
        examLabel
        imageExam {
          id
          name
          productType {
            prescriptionSeparate
          }
        }
        files {
          id
          fileKey
          originalName
          mimetype
          sizeBytes
          bucket
          path
        }
      }
      appointmentHistoryLicenses {
        id
        days
        description
        appointmentId
        code
        date
        licensesTypes {
          id
          name
          description
          maxDays
        }
      }
      appointmentHistoryReferral {
        id
        patientId
        observation
        medicalName
        speciality {
          id
          name
        }
      }
    }
  }
`;

export const OPTIONS = gql`
  query options($where: OptionWhereInput) {
    items: options(where: $where) {
      id
      name
      value
      type
    }
  }
`;

export const GET_AVAILABLE_QUANTITY = gql`
  query getAvailableQuantity($where: QuotationsDetailI) {
    getAvailableQuantity(where: $where) {
      availableQuantity
    }
  }
`;

export const UPDATE_PATIENT_DATE_OF_BIRTH = gql`
  mutation UpdatePatient(
    $data: AffiliateUpdateInput!
    $where: AffiliateWhereInput!
  ) {
    updateAffiliate(data: $data, where: $where) {
      id
    }
  }
`;

export const UPDATE_PATIENT_DENIES_HISTORY = gql`
  mutation updateAffiliate(
    $data: AffiliateUpdateInput!
    $where: AffiliateWhereInput!
  ) {
    updateAffiliate(data: $data, where: $where) {
      id
      deniesHistory
    }
  }
`;

export const GET_ALLERGY_PER_PATIENT = gql`
  query getAllergyPerPatient(
    $where: AllergyPerPatientWhereInput
    $relations: [String]
  ) {
    getAllergyPerPatient(where: $where, relations: $relations) {
      id
      type
      molecule {
        id
        name
      }
      allergyGroup {
        id
        name
      }
    }
  }
`;

export const SAVE_ALLERGY_PER_PATIENT = gql`
  mutation saveAllergyPerPatient($data: [AllergyPerPatientWhereInput]) {
    saveAllergyPerPatient(data: $data)
  }
`;

export const VALIDATE_PATIENT_ALLERGY_GROUP = gql`
  query validatePatientAllergyGroup($where: AllergyPerPatientWhereInput) {
    validatePatientAllergyGroup(where: $where) {
      medicineName
      moleculeName
    }
  }
`;
